module.exports = __webpack_public_path__ + "img/B266.6e3e869a.png";